import React, { useState, useRef, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import axios from "axios";
import { SERVICE_LOCATION, GET_REJECTED_BY_ACCOUNTS } from "../constants/endpoints";

import "./../assets/styles/table.css";
import "./../assets/styles/fitter.css";
import "./../assets/styles/reports.css";

const RejectByAccountsReport = (props) => {
    const { data } = props;

    const toast = useRef(null);

    const [rejectedAccountsReportData, setRejectedAccountsReportData] = useState(null);
    const [filteredReportData, setFilteredReportData] = useState(null);
    const [loading, setLoading] = useState(false);

    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState("");

    useEffect(() => {
        getRejectedAcountsData();
        initFilters();
    }, []);

    const getRejectedAcountsData = () => {
        setLoading(true);
        const endPoint = SERVICE_LOCATION + GET_REJECTED_BY_ACCOUNTS;
        axios.get(endPoint, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                setLoading(false);
                if (response.data.isSuccess) {
                    const rejectedAccountsData = response.data.data.rejectedAccounts;
                    setRejectedAccountsReportData(rejectedAccountsData);
                    setFilteredReportData(rejectedAccountsData);
                }
                else if (!response.data.isSuccess) {
                    setRejectedAccountsReportData(null);
                    setFilteredReportData(null);

                }
            })
            .catch((error) => {
                setRejectedAccountsReportData(null);
                setFilteredReportData(null);
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
            })
    };

    const getFilteredReportData = (filteredData) => {
        setFilteredReportData(filteredData);
    }

    //export functionality
    const saveAsExcelFile = (buffer, fileName) => {
        import("file-saver").then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                let EXCEL_EXTENSION = ".xlsx";
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    };

    const exportExcel = () => {
        import("xlsx").then((xlsx) => {
            const worksheet = xlsx.utils.json_to_sheet(filteredReportData);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer = xlsx.write(workbook, {
                bookType: "xlsx",
                type: "array"
            });

            saveAsExcelFile(excelBuffer, "RejectedByAccountsReport");
        });
    };
    //end export functionality

    // Search functionality
    const clearFilter = () => {
        initFilters();
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            clientAccount: { value: null, matchMode: FilterMatchMode.CONTAINS },
            clientName: { value: null, matchMode: FilterMatchMode.CONTAINS },
            systemId: { value: null, matchMode: FilterMatchMode.CONTAINS },
            siteRefNo: { value: null, matchMode: FilterMatchMode.CONTAINS },
            site: { value: null, matchMode: FilterMatchMode.CONTAINS },
            measureId: { value: null, matchMode: FilterMatchMode.CONTAINS },
            worksheetNo: { value: null, matchMode: FilterMatchMode.CONTAINS },
            product: { value: null, matchMode: FilterMatchMode.CONTAINS },
            paymentCardRequired: { value: null, matchMode: FilterMatchMode.CONTAINS },
            rejectReason: { value: null, matchMode: FilterMatchMode.CONTAINS },
            invoiceStatusUpdatedBy: { value: null, matchMode: FilterMatchMode.CONTAINS },
            paymentCardIncluded: { value: null, matchMode: FilterMatchMode.CONTAINS },
            plannedDate: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        setGlobalFilterValue("");
    }

    const renderHeader = () => {
        return (
            <div className="row">
                <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                    <div className="flex align-items-center justify-content-end gap-2">
                        <Button className="mar-r-10" type="button" icon="pi pi-file-excel" severity="success" onClick={exportExcel} rounded tooltip="Export Report" />
                    </div>
                </div>
                <div className="col-12 col-sm-9 col-md-9 col-lg-9 col-xl-9">
                    <div className="flex justify-content-end txt-right">
                        <Button className="mar-r-10" type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} tooltip="clear filters" tooltipOptions={{ position: "bottom" }} />
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                        </span>
                    </div>
                </div>

            </div>
        );
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const header = renderHeader();
    // Search functionality Ends here    

    return (
        <div className={`app ${loading ? "disabled" : ""}`}>
            {
                loading &&
                <div className="spinner-overlay">
                    <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                </div>
            }

            <Toast ref={toast} />

            <div className="worksheets-section padl-20">
                <h4>Rejected By Accounts Report</h4>

                <div className="row">
                    <div className="col-12">
                        <DataTable className="font-12" value={rejectedAccountsReportData} dataKey="measureId" paginator rows={10}
                            rowsPerPageOptions={[10, 25, 50]} filters={filters} header={header} filterDisplay="row" onValueChange={getFilteredReportData}
                            globalFilterFields={["clientAccount", "clientName", "systemId", "siteRefNo", "site", "measureId", "worksheetNo",
                                "product", "paymentCardRequired", "paymentCardIncluded", "rejectReason", "invoiceStatusUpdatedBy", "plannedDate"]}
                            scrollable tableStyle={{ minWidth: "100rem" }} emptyMessage="No rejected accounts availabe">
                            <Column field="clientAccount" key="Client Account" header="Client Account" filter filterPlaceholder="Search by client account" className="table-header"></Column>
                            <Column field="clientName" header="Client Name" filter filterPlaceholder="Search by description" className="table-header" ></Column>
                            <Column field="systemId" header="SystemId" filter filterPlaceholder="Search by systemId" className="table-header" hidden></Column>
                            <Column field="siteRefNo" header="SiteRefNo" filter filterPlaceholder="Search by site refNo" className="table-header"></Column>
                            <Column field="site" header="site" filter filterPlaceholder="Search by site" className="table-header"></Column>
                            <Column field="measureId" header="Measure Id" filter filterPlaceholder="Search by measureId" className="table-header"></Column>
                            <Column field="worksheetNo" header="Worksheet No" filter filterPlaceholder="Search by worksheetNo" className="table-header"></Column>
                            <Column field="product" header="Product" filter filterPlaceholder="Search by product" className="table-header"></Column>
                            <Column field="plannedDate" header="Planned Date" filter filterPlaceholder="Search by planned date" className="table-header"></Column>
                            <Column field="paymentCardRequired" header="PaymentCard Required" filter filterPlaceholder="Search by paymentcard required" className="table-header"></Column>
                            <Column field="paymentCardIncluded" header="PaymentCard Included" filter filterPlaceholder="Search by paymentCard included" className="table-header"></Column>
                            <Column field="rejectReason" header="Reject Reason" filter filterPlaceholder="Search by reject reason" className="table-header"></Column>
                            <Column field="invoiceStatusUpdatedBy" header="Rejected By" filter filterPlaceholder="Search by invoice Status updatedBy" className="table-header"></Column>
                        </DataTable>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RejectByAccountsReport;